import React from 'react';
import { Link } from 'react-router-dom';
import SubPage from '../SubPage';
import Board from '../Board';
import { useLang } from '../../LanguageContext';

const CRUMB = { ko: '고객 센터', en: 'Support' };
const T = {
  title: { ko: '공지 사항', en: 'Notices' },
  lede:  { ko: '메디로지스의 주요 공지사항을 안내드립니다.',
           en: 'Announcements from MEDILOGIS.' },
  tag:   { ko: '공지', en: 'Notice' },
  note:  { ko: <>공지 사항은 회사가 직접 알리는 안내글입니다. 서비스 점검, 이용 안내, 제품 업데이트 등이 올라갑니다.
                언론 보도·수상·협약 소식은 <Link to="/news/press">소식 자료 › 보도 자료</Link>에서 보실 수 있습니다.</>,
           en: <>Notices are announcements written by MEDILOGIS — service maintenance, usage guides and product updates.
                Press coverage, awards and agreements are under <Link to="/news/press">News › Press</Link>.</> },
};

function Notice() {
  const { lang } = useLang();
  return (
    <SubPage crumb={CRUMB[lang]} title={T.title[lang]} lede={T.lede[lang]}>
      <Board category="NOTICE" tag={T.tag} />
      <div className="sp-note sp-mt">{T.note[lang]}</div>
    </SubPage>
  );
}

export default Notice;
